export const GAME_SERVERS_ENUM_RESOURCES = [
  'EventTaskType',
  'CounterType',
  'PiggyBankSize',
  'MailType',
  'AchievementCategory',
  'AchievementType',
  'BoxType',
  'BuildSource',
  'GameStatType',
  'ChatSilenceReason',
  'ChatType',
  'CounterType',
  'CurrencyType',
  'DestinationType',
  'ErrorType',
  'GearType',
  'GuildRole',
  'HeroType',
  'HeroShowcaseID',
  'IAPProduct',
  'MonthlyCardType',
  'ItemTypeSelection',
  'ModeratorType',
  'OutpostFarmingEvents',
  'PaymentSource',
  'Rarity',
  'ReferralEventType',
  'ResourceType',
  'SalePackageType',
  'Shard',
  'SuspensionReason',
  'TutorialActType',
  'ResourceBurnReason',
  'QuestID',
  'AnimationSequenceType',
  'EventCurrencyType',
  'ResourceCategory',
  'JiggleType',
  'EventLeaderboardType',
  'ResetPeriodType',
  'EventLeaderboardTaskType',
  'GameMode',
  'GameModeStatType',
  'CombatTag',
  'CombatTagFull',
  'EventBoxType',
  'ChestType',
  'CombatStatType',
  'DayDefinition',
  'RewardsAlignment',
  'EnemyType',
] as const;
